$(document).ready(function() {

  // Push Menu
  // *********:
  var item = $('.push-nav__item');
  // check if it has child menu and add class if so
  item.each(function(){
    if (this.children.length > 1) {
      $(this).addClass('has-child-menu');
      modifyDecendantIdForAriaIfRequired($(this));
    }
    // tabindex on .push-nav__item for focus
    $(this).attr('tabindex', 1);
  });

  function getUniqueId(){
    var randLetter = Math.random().toString(36).slice(2, 7);
    return randLetter + Date.now();
  }

  // This is to make sure that all decendant childs are not considered in NVDA.
  // Only first anchor will be considered.
  function modifyDecendantIdForAriaIfRequired(elem){
    let firstChild = elem.children('a').first();
    if(firstChild.attr('id') == undefined) {
      let anchorId = 'id' + getUniqueId();
      firstChild.attr('id', anchorId);
      elem.attr('aria-activedescendant',anchorId);
    } else if(elem.children('a').length > 0 ){
      elem.attr('aria-activedescendant', firstChild.attr('id'));
    }
    firstChild.attr('aria-live', "assertive");
    firstChild.attr('aria-expanded', "false");
  }
 
  // .has-child click
  $('.push-nav__item.has-child-menu').on('click',  function childClicked(e){
    //e.stopPropagation();
    $(".js-nav-dropdown").addClass("nav-active").find("[class*='icon--']").addClass("icon--arrow-left").removeClass("icon--cross");
    //$('.push-nav__list').removeClass('active');
    $(this).children('.push-nav__list').addClass('active');
    $(this).parent().addClass('inactive').removeClass('active');
    document.activeElement.blur();
    //e.preventDefault();
});

  function handleFocusOnNextPageElement(el) {
    if(el.get(0) != undefined && el.get(0).classList.contains("active") && !el.get(0).classList.contains("inactive")) {
      // To manage the race conditions due to transition (0.5s) we need to push timeout => transition time.
      setTimeout(() => {
        el.find(".push-nav__item:first").get(0).focus();
      }, 500);
    }
  }


  $('.push-nav__item').on('keydown', function(event){
    let current = $(this);
    // Managing the focus for internal <ul> having active class.
    let isParentActive = $(this).parent().hasClass("active") && !$(this).parent().hasClass("inactive");
   
      if(event.keyCode == 9 && isParentActive ){
        if(event.shiftKey) {
          setTimeout(function(){
            if(current.prev().get(0) !== undefined && current.prev().hasClass("push-nav__item")) {
              current.prev().get(0).focus();
            } else {
              $('.js-nav-dropdown.nav__menu').focus();
            }
    
          },10)
        } else {
          setTimeout(function(){
            if(current.next().get(0) !== undefined) {
               current.next().get(0).focus();
            }
          },10)
        }
        event.stopPropagation();
        event.preventDefault();
      }
      
      // Handling enter as click (Similar to click event)
      if(event.keyCode == 13){
        current.get(0).blur();
        if(current.get(0).classList.contains("has-child-menu")) {
          $(".js-nav-dropdown").addClass("nav-active").find("[class*='icon--']").addClass("icon--arrow-left").removeClass("icon--cross");
          $(this).children('.push-nav__list').addClass('active');
          $(this).parent().addClass('inactive').removeClass('active');
          handleFocusOnNextPageElement(current.children('.push-nav__list'))
        } else {
          // If the child is not present than click the underline anchor link
          $(this).children().get(0).click();
        }
      }
  });


// Managing the behaviour for nav button in case the underline ul is active. 
  $(document).on("keydown", ".js-nav-dropdown.nav-active", function(e) {
    if(e.keyCode == 9){
      if(e.shiftKey) {
        e.stopPropagation();
        e.preventDefault();
      } else {
        // Get the active <ul> and focus on the first "li.push-nav__item" 
        setTimeout(function(){
          let ulElm  = $('.push-nav__list.active:not(.inactive):not(.push-nav__list--top)')
          if(ulElm.find("li.push-nav__item").first() != null){
            ulElm.find("li.push-nav__item").first().get(0).focus();
          }
        }, 50)
      }
    }
  })

  $(document).on("keydown", ".js-nav-dropdown:not(.nav-active)", function(e) {
   // Login case adds more .push-nav__list <ul> elements but we are interested in only .mobile-menu--nav 
   if((e.keyCode == 13 || e.keyCode == 9) && $('.push-nav__list').first().parents('.mobile-menu--nav').length == 0) {
       $('.push-nav__list').get(1).classList.add('active')
    }
  })

  $(document).on("click", ".js-nav-dropdown.nav-active", function(e) {
    e.preventDefault();
    e.stopPropagation();

    if( $(".push-nav__list--l2").hasClass("active") ) {
      // level 2 active
      $(".push-nav__list--l2").removeClass('active');
      $(".push-nav__list--l1").removeClass('inactive');
    } else if ($(".push-nav__list--l1").hasClass("active")) {
      // level 1
      $(".push-nav__list--l1").removeClass('active');
      $(".push-nav__list--top").removeClass('inactive');
      $(".js-nav-dropdown").removeClass("nav-active").find("[class*='icon--']").removeClass("icon--arrow-left").addClass("icon--cross");

      var element = $("#mobileHeaderMainLink-Shop");
      if (element && element.length > 0) {
        setAriaExpandedValue(element[0], 'false');
      }
    }
    
  });
});